export default (props) => ({
  __typename: props.__typename,
  introCandidate: props.intro_candidate,
  introCompany: props.intro_company,
  promiseCompany: props.promise_company,
  promiseCandidate: props.promise_candidate,
})
